'use client';

import { Text } from '@chakra-ui/react';
import { useInterval } from '@willbooster/shared-lib-react';
import type React from 'react';
import { useState } from 'react';

import type { SupportedLanguage } from '@/__generated__/i18n';
import { useI18n } from '@/__generated__/i18n.next';
import { humanizeDuration } from '@/utils/dayjs';

interface Props {
  closedAt: Date;
  locale: SupportedLanguage;
}

export const ContestRemainingTime: React.FC<Props> = ({ closedAt, locale }) => {
  const t = useI18n();
  const [remainingTime, setRemainingTime] = useState('');
  useInterval(() => {
    const difference = closedAt.getTime() - Date.now();
    setRemainingTime(difference > 0 ? humanizeDuration(difference, locale) : t.components.contestTimer.finished());
  }, 1000);

  return <Text>{remainingTime}</Text>;
};
